import React, { useEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import './ContentStyle.css';
import ApiSender from '../common/ApiLogic';

function ErrorPage() {
  
  const location = useLocation();
  const params = useMemo(() => new URLSearchParams(location.search), [location.search]);

  useEffect(() => {
    async function begin() {
      const apiSender = new ApiSender();
      apiSender.sendLogs("error", params);
    }
    begin();
  }, []);

  const redirectToGamePortal = () => {
    window.location.href = process.env.REACT_APP_GAME_PORTAL;
  };

  return (
    <div className="Aa000">
      <div className='container'>
        <div className='header'>
          <div className='logo'><img alt='GameLand' src='%PUBLIC_URL%/../../gameland-logo.png' /></div>
        </div>
        <div className='form-content'>
          <div className='form-content-top'>
            <div className='logo'><img alt='GameLand' src='%PUBLIC_URL%/../../gameland-banner.png' /></div>
          </div>
          <div className='title'>
            <h4>Please turn on Mobile Data and try again</h4>
          </div>
          <div className='button'>
            <button onClick={redirectToGamePortal}>Discover Games</button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ErrorPage;